module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "height": "100%"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success === false),
      expression: "success === false"
    }]
  }, [_c('div', {
    staticClass: "header header4"
  }, [_c('div', {
    staticClass: "header-main"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "clear1"
  }), _vm._v(" "), _c('div', {
    staticClass: "header-right"
  }, [_c('button', {
    staticClass: "header-but1",
    staticStyle: {
      "margin-top": "5%",
      "color": "#000"
    },
    attrs: {
      "id": "header-but1"
    },
    on: {
      "click": function($event) {
        _vm.$router.push('newyearactivityrule')
      }
    }
  }, [_vm._v("活动详情\n                    ")])]), _vm._v(" "), _c('div', {
    staticClass: "header-footer",
    staticStyle: {
      "color": "#000"
    }
  }, [_vm._v("新用户*赢现金红包，推荐人得现金奖励")])])]), _vm._v(" "), _vm._l((_vm.questions), function(item, index) {
    return _c('checklist', {
      key: item.id,
      attrs: {
        "title": item.title,
        "options": item.answerChooseList,
        "max": 1
      },
      model: {
        value: (_vm.answer[index]),
        callback: function($$v) {
          _vm.$set(_vm.answer, index, $$v)
        },
        expression: "answer[index]"
      }
    })
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "padding": "10px"
    }
  }, [_c('x-button', {
    attrs: {
      "type": "primary",
      "disabled": _vm.hasAccess === false || (_vm.hasAccess && _vm.noSubmit)
    },
    nativeOn: {
      "click": function($event) {
        _vm.submit($event)
      }
    }
  }, [_vm._v("\n                " + _vm._s(_vm.textBtn) + "\n            ")])], 1)], 2), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.success === true),
      expression: "success === true"
    }],
    staticClass: "body",
    attrs: {
      "id": "success"
    }
  }, [_c('button', {
    class: [_vm.hdClassBtn, {
      main_jb2: _vm.trans
    }],
    on: {
      "click": _vm.openRedPackage
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "win1",
    style: ({
      display: _vm.redPackageDisplay
    }),
    attrs: {
      "id": "receive1"
    }
  }, [_c('div', {
    staticClass: "winBody2"
  }, [_c('div', {
    staticClass: "receive1-bg1"
  }, [_c('div', {
    staticClass: "receive1-head"
  }, [_c('h1', [_vm._v(_vm._s(_vm.redPackAmount) + "元"), _c('br'), _vm._v("现金红包")])]), _vm._v(" "), _c('div', {
    staticClass: "receive1-body"
  }, [_c('p', [_vm._v("恭喜您"), _c('br'), _vm._v("成功领取红包"), _c('br'), _vm._v("您只需支付 " + _vm._s(_vm.needAmount) + " 或 " + _vm._s(_vm.needAmount + 8) + " 元邮费(偏远地区)"), _c('br'), _vm._v(" 可得\n                        护眼水体验装 x 1\n                    ")])]), _vm._v(" "), _c('button', {
    staticClass: "receive1-but1",
    on: {
      "click": function($event) {
        _vm.success && _vm.$router.push('/shop/cate/8')
      }
    }
  }, [_vm._v("使用红包")]), _vm._v(" "), _c('div', {
    staticClass: "receive1-bg2"
  })])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-left"
  }, [_c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("有奖 ")]), _vm._v("传播生态护眼的爱心")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "margin-top": "15px",
      "color": "#000"
    }
  }, [_c('b', {
    staticStyle: {
      "color": "#09bb07"
    }
  }, [_vm._v("免费 ")]), _vm._v("体验改变视界的感受")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39e52ff0"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/newYearActivity/from.vue
// module id = 669
// module chunks = 0